import { loadVulnerabilityList, loadVulnerability, loadVulnerabilityDistributions, removeDistributionFromVulnerability } from '@/api/super'
import Vulnerability from '@/store/models/Vulnerability'

let vulnerabilityModel = new Vulnerability

export default {

  namespaced: true,

  state: {
    vulnerabilitiesList: [],
    vulnerability: vulnerabilityModel
  },

  mutations: {
    ...vulnerabilityModel.mutations(),
    setVulnerabilitiesList: (state, payload) => state.vulnerabilitiesList = payload
  },

  actions: {
    loadVulnerabilitiesList: ({commit}) => new Promise((resolve, reject) => {
      loadVulnerabilityList(({data}) => {
        commit('setVulnerabilitiesList', data)
        resolve()
      }, reject)
    }),
    loadVulnerability: ({commit}, vulnerabilityId) => new Promise((resolve, reject) => {
      loadVulnerability(vulnerabilityId, ({data}) => {
        commit('setVulnerability', data)
        resolve()
      }, reject)
    }),
    loadDistributions: ({commit}, vulnerabilityId) => new Promise((resolve, reject) => {
      loadVulnerabilityDistributions(vulnerabilityId, ({data}) => {
        commit('setDistributions', data)
        resolve()
      }, reject)
    }),
    removeDistribution: ({commit}, payload) => new Promise((resolve, reject) => {
      removeDistributionFromVulnerability(payload, () => {
        commit('removeVulnerbility', payload.vulnerability)
        resolve()
      }, reject)
    }),
  },

  getters: {
    vulnerabilitiesList: state => state.vulnerabilitiesList,
    vulnerability: state => state.vulnerability,
  }
}